import { Application } from "@pixi/react";
import "pixi.js/accessibility";
import { ComponentProps } from "react";

export function WebGLIsland({
  children,
  resolution = 1,
  powerPreference = "high-performance",
  autoDensity = true,
  sharedTicker = true,
  backgroundAlpha = 0,
  antialias = true,
  ...props
}: ComponentProps<typeof Application>) {
  return (
    <Application
      {...props}
      backgroundAlpha={backgroundAlpha}
      sharedTicker={sharedTicker}
      autoDensity={autoDensity}
      powerPreference={powerPreference}
      resolution={resolution}
      antialias={antialias}
    >
      {children}
    </Application>
  );
}
